import { Middleware, Action } from 'redux'
import axios from 'axios'
import { FETCH_TIMINGS_SUCCEEDED, FOCUSMATCHSTATUS_VALIDATED, CHANGE_CHANNEL, MATCH_PURGE } from '../actions/actionTypes'
import { STATUS_MATCH_ENDED } from '../reducers/matches'
import { getActiveChannelId } from '../reducers/gui'
import { ITimingsChannel } from '../store/state'

const focusMatchMiddleware: Middleware = store => next => action => {
    switch(action.type) {
        case FETCH_TIMINGS_SUCCEEDED:
            const state: any = store.getState() // TODO: set a typedeclaration that works (generic?)
            const result = next(action) // TODO: set a typedeclaration that works (generic?)
            // purge all matches that are not active anymore
            // TODO: do we really have to compare data from action with data from next() result here ?
            const nextMatches:number[] = Object.values((result as any).data.timings.channels).map(function(channel:any) {
                return channel.match_id;
            })
            const matches:number[] = (action as any).data.timings.channels.map(function(channel:any) {
                return channel.match_id;
            })
            var inactiveMatches:number[] = nextMatches.filter((match:any) => { 
                return !(matches.includes(match))
            })
            for(const inactiveMatch of inactiveMatches) {
                store.dispatch({type: MATCH_PURGE, id: inactiveMatch})
            }
            if(nextMatches.includes(state.config.focusmatchid)) { // match is active
                const nextChannelid: number = (result as any).data.timings.channels.find(function(value: ITimingsChannel ) {
                    return value.match_id == state.config.focusmatchid
                }).id
                const channelid: number = getActiveChannelId(state)
                if(nextChannelid!=channelid) {
                    store.dispatch({type: CHANGE_CHANNEL, id: nextChannelid}) // set corresponding channel
                }
                store.dispatch({type: FOCUSMATCHSTATUS_VALIDATED, status: 'active'}) // render active status
            }else { // match is inactive
                store.dispatch({type: FOCUSMATCHSTATUS_VALIDATED, status: 'error'}) // render error status
            }
            return result
    }
    return next(action)
}

export default focusMatchMiddleware